export const getHttpPrefix = ()=>process.env.useHTTPS === 'true' ? 'https:' : 'http:';
